import React, { useEffect } from "react";
// import Tooltip from "../Tooltip";
// import { useTimerContext } from "@/context/TimerContext";

// type Range = { min: number; max: number } | null;

const StatusCards = ({
    // setScoreRange,
    setCategory,
    setCurrentPage,
    category,
    count
}: {
    setScoreRange: React.Dispatch<React.SetStateAction<any>>;
    setCategory: React.Dispatch<React.SetStateAction<string>>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>
    category: string;
    count: {
        reviewCount: number,
        shortlistedCount: number,
        rejectedCount: number,
        screeningCount: number
    }

}) => {
    // const [selectedRanges, setSelectedRanges] = useState<{
    //     shortlisted: Range;
    //     review: Range;
    //     rejected: Range;

    // }>({
    //     shortlisted: { min: 70, max: 100 },
    //     review: { min: 59, max: 69 },
    //     rejected: { min: 0, max: 58 },
    // });
    // const { formatTime, setTimeLeft, timeLeft } = useTimerContext()
    // const getShortlistedRanges = () => [
    //     { label: "100-90", min: 90, max: 100 },
    //     { label: "100-80", min: 80, max: 100 },
    //     { label: "100-70", min: 70, max: 100 },
    //     { label: "100-60", min: 60, max: 100 },
    // ];

    // const getReviewRanges = (shortlistedMin?: number) => {
    //     const upper = (shortlistedMin ?? selectedRanges.shortlisted?.min ?? 90) - 1;
    //     const base = [];
    //     for (let i = upper; i > 40; i -= 10) {
    //         const lower = i - 10 < 40 ? 40 : i - 10;
    //         base.push({
    //             label: `${upper}-${lower}`,
    //             min: lower,
    //             max: upper,
    //         });
    //     }
    //     return base;
    // };

    // const getRejectedRanges = (reviewMin?: number) => {
    //     const upper = (reviewMin ?? selectedRanges.review?.min ?? 50) - 1;
    //     const base = [];
    //     base.push({
    //         label: `${upper}-0`,
    //         min: 0,
    //         max: upper,
    //     });

    //     return base;
    // };


    // const handleSelect = (status: string, range: { min: number; max: number }) => {
    //     const updated = { ...selectedRanges, [status]: range };

    //     if (status === "shortlisted") {
    //         const newReviewRanges = getReviewRanges(range.min);
    //         const newReview = newReviewRanges.length ? newReviewRanges[0] : null;

    //         const newRejectedRanges = getRejectedRanges(newReview?.min ?? 50);
    //         const newRejected = newRejectedRanges.length ? newRejectedRanges[0] : null;

    //         updated.review = newReview;
    //         updated.rejected = newRejected;
    //     } else if (status === "review") {
    //         const newRejectedRanges = getRejectedRanges(range.min);
    //         updated.rejected = newRejectedRanges.length ? newRejectedRanges[0] : null;
    //     }

    //     setScoreRange({
    //         shortListedMinScore: updated.shortlisted?.min,
    //         shortListedMaxScore: updated.shortlisted?.max,
    //         ReviewMinScore: updated.review?.min,
    //         ReviewMaxScore: updated.review?.max,
    //         RejectedMinScore: updated.rejected?.min,
    //         RejectedMaxScore: updated.rejected?.max,
    //     })

    //     setSelectedRanges(updated);
    // };
    useEffect(() => {
        setCurrentPage(1)
    }, [category])

    // useEffect(() => {

    //     if (!count.screeningCount) return;
    //     setTimeLeft(count.screeningCount * 10)
    // }, [count]);

    return (
        <div className="w-full mt-10 mb-2">
            <div className="md:flex items-center gap-10 md:border-b space-y-5 md:space-y-0">
                {/* Shortlisted */}
                <div
                    className={`cursor-pointer pb-2 mb-[-1px] w-max ${category === "shortlisted" ? "border-b-2 border-[#007B5D]" : ""}`}
                    onClick={() => setCategory("shortlisted")}
                >
                    <div className="flex items-center gap-2">
                        <span className={`${category === "shortlisted" ? "text-[#007B5D] font-semibold" : "text-gray-500"}`}>Shortlisted</span>
                        <span className="bg-[#BDE4C3] text-[#007B5D] px-2 py-0.5 rounded-md text-sm font-medium">{count.shortlistedCount}</span>
                    </div>
                </div>

                {/* Review Later */}
                <div
                    className={`w-max cursor-pointer pb-2 mb-[-1px] ${category === "review" ? "border-b-2 border-[#007B5D]" : ""}`}
                    onClick={() => setCategory("review")}
                >
                    <div className="flex items-center gap-2">
                        <span className={`${category === "review" ? "text-[#007B5D] font-semibold" : "text-gray-500"}`}>Review Later</span>
                        <span className="bg-[#F7F1CE] text-[#F19B4F] px-2 py-0.5 rounded-md text-sm font-medium">{count.reviewCount}</span>
                    </div>
                </div>

                {/* Rejected/Archive */}
                <div
                    className={`w-max cursor-pointer pb-2 mb-[-1px] ${category === "rejected" ? "border-b-2 border-[#007B5D]" : ""}`}
                    onClick={() => setCategory("rejected")}
                >
                    <div className="flex items-center gap-2">
                        <span className={`${category === "rejected" ? "text-[#007B5D] font-semibold" : "text-gray-500"}`}>Rejected/Archive</span>
                        <span className="bg-[#F7C5C5] text-[#CA4F4F] px-2 py-0.5 rounded-md text-sm font-medium">{count.rejectedCount}</span>
                    </div>
                </div>
                {count.screeningCount !== 0 && (
                    <div
                    >

                        <div
                            className={`w-max cursor-pointer pb-2 mb-[-1px] ${category === "screening" ? "border-b-2 border-[#007B5D]" : ""}`}
                            onClick={() => setCategory("screening")}
                        >
                            <div className="flex items-center gap-2">

                                <span className={`${category === "screening" ? "text-[#007B5D] font-semibold" : "text-gray-500"}`}>Screening</span>
                                <span className="bg-blue-100 text-blue-500 px-2 py-0.5 rounded-md text-sm font-medium">
                                    {count.screeningCount}
                                </span>
                            </div>
                        </div>

                    </div>
                )}
            </div>
            {/* Shortlisted Dropdown
            {category === "shortlisted" && (
                <div className="flex gap-2 items-center mt-2">
                    <label>ATS Score Range:
                    </label>
                    <select
                        className="mt-1 block border border-gray-300 rounded-md px-2 py-1 text-sm "

                        onChange={(e) => {
                            const [min, max] = e.target.value.split("-").map(Number);
                            handleSelect("shortlisted", { min, max });
                        }}
                        value={
                            selectedRanges.shortlisted
                                ? `${selectedRanges.shortlisted.min}-${selectedRanges.shortlisted.max}`
                                : ""
                        }
                    >
                        <option value="" disabled>Select Range</option>
                        {getShortlistedRanges().map((range, i) => (
                            <option key={i} value={`${range.min}-${range.max}`}>{range.label}</option>
                        ))}
                    </select>
                </div>
            )}

            {/* Review Dropdown */}
            {/* {category === "review" && (
                <div className="flex gap-2 items-center mt-2">
                    <label>ATS Score Range:
                    </label>
                    <select
                        className="mt-1 block border border-gray-300 rounded-md px-2 py-1 text-sm "
                        onChange={(e) => {
                            const [min, max] = e.target.value.split("-").map(Number);
                            handleSelect("review", { min, max });
                        }}
                        value={
                            selectedRanges.review
                                ? `${selectedRanges.review.min}-${selectedRanges.review.max}`
                                : ""
                        }
                    >
                        <option value="" disabled>Select Range</option>
                        {getReviewRanges().map((range, i) => (
                            <option key={i} value={`${range.min}-${range.max}`}>{range.label}</option>
                        ))}
                    </select>
                </div>
            )} */}

            {/* Rejected Dropdown */}
            {/* {category === "rejected" && (
                <div className="flex gap-2 items-center mt-2">
                    <label>ATS Score Range:
                    </label>
                    <select
                        className="mt-1 block border border-gray-300 rounded-md px-2 py-1 text-sm "
                        onChange={(e) => {
                            const [min, max] = e.target.value.split("-").map(Number);
                            handleSelect("rejected", { min, max });
                        }}
                        value={
                            selectedRanges.rejected
                                ? `${selectedRanges.rejected.min}-${selectedRanges.rejected.max}`
                                : ""
                        }
                    >
                        <option value="" disabled>Select Range</option>
                        {getRejectedRanges().map((range, i) => (
                            <option key={i} value={`${range.min}-${range.max}`}>{range.label}</option>
                        ))}
                    </select>
                </div>
            )} */}

            {/* Screening Section */}
            {/* {
                category === "screening" && <div className="mt-2.5 block">
                    <label>Estimated Time: {formatTime(timeLeft)}</label>
                </div>
            }  */}
        </div>

    );
};

export default StatusCards;
